//
//
//
//
//
//

export default {
    name: "Container",

    props: {
        fluid: {
            type: Boolean,
            default: false,
        },

        tight: {
            type: Boolean,
            default: false,
        },

        // Whether the container shall gain a tight padding on 'xs' devices
        xsTight: {
            type: Boolean,
            default: false
        },

        // A custom padding to overwrite the default
        customPadding: {
            type: String,
            default: null
        },

        // Whether the container shall gain full width
        full: {
            type: Boolean,
            default: false
        },

        // Whether the container shall gain full width on 'xs' devices
        xsFull: {
            type: Boolean,
            default: false
        },

        // Whether the container shall gain full width on 'sm' devices
        smFull: {
            type: Boolean,
            default: false
        },

        // Whether the container shall gain full width on 'md' devices
        mdFull: {
            type: Boolean,
            default: false
        },

        // Whether the container shall gain full width on 'lg' devices
        lgFull: {
            type: Boolean,
            default: false
        },

        // Whether the container shall gain full width on 'xl' devices
        xlFull: {
            type: Boolean,
            default: false
        },
    },

    computed: {
        paddingClass() {
            if (this.customPadding) {
                return this.customPadding;
            }

            let padding = this.full ? [] : ['px-16'];

            if (this.xlFull) {
                padding.push('xl:px-0')
            }

            if (this.lgFull) {
                padding.push('lg:px-0')

                if (!this.xlFull) {
                    padding.push('xl:px-16')
                }
            }

            if (this.mdFull) {
                padding.push('md:px-0')

                if (!this.lgFull) {
                    padding.push('lg:px-16')
                }
            }

            if (this.smFull) {
                padding.push('sm:px-0')

                if (!this.mdFull) {
                    padding.push('md:px-16')
                }
            }

            if (this.xsFull) {
                padding.push('xs:px-0')

                if (!this.smFull) {
                    padding.push('sm:px-16')
                }
            } else if (this.xsTight) {
                padding.push('xs:px-8')

                if (!this.smTight) {
                    padding.push('sm:px-16')
                }
            }

            return padding.join(' ')
        }
    }
}
